import X from 'lucide-react/dist/esm/icons/x.mjs'

export function ModalShell({ eyebrow, title, children, footer, close, className = '' }) {
  return <div className="modal-backdrop" onMouseDown={event => event.target === event.currentTarget && close()}>
    <section className={`modal ${className}`} role="dialog" aria-modal="true" aria-label={title}>
      <div className="modal-head"><div><span>{eyebrow}</span><h2>{title}</h2></div><button className="icon-button" onClick={close} aria-label="关闭"><X size={20}/></button></div>
      {children}
      {footer ? <div className="modal-actions">{footer}</div> : null}
    </section>
  </div>
}
